// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Caml_option from "../../../../rescript/lib/es6/caml_option.js";

function handleAPIRequest(apiRequest, onSuccess, onError) {
  Curry._1(apiRequest, undefined).then(function (result) {
        if (result.TAG === /* Ok */0) {
          return Promise.resolve(Curry._1(onSuccess, result._0));
        } else {
          return Promise.resolve(Curry._1(onError, result._0));
        }
      });
  
}

function resolveRepoResponse(handleResponse) {
  var data = Curry._1(handleResponse, undefined);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* DefaultError */{
                  _0: {
                    title: /* InternalServerError */3,
                    message: "Something went wrong"
                  }
                }
              });
  }
}

export {
  handleAPIRequest ,
  resolveRepoResponse ,
  
}
/* No side effect */
